import React from "react";
import MuiTooltip from '@mui/material/Tooltip';
import styles from './Tooltip.module.scss'
import { combineClasses } from "utils/utils"
import { styled } from '@mui/material/styles';
import { tooltipClasses } from '@mui/material/Tooltip';



const Tooltip = ({ ...props }) => {
  return (
    <span className={combineClasses(styles.tooltipContainer, props.className)}>
      {/* {props.type === "text" ? ( */}
      <MuiTooltip title={props.tooltip}>
        {props.text}
      </MuiTooltip>
    </span>
  );
};
const CustomWidthTooltip = styled(({ className, ...props }) => (
  <span className={combineClasses(styles.tooltipContainer, props.className)}>
    <MuiTooltip title={props.tooltip} classes={{ popper: className }}>
      {props.text}
    </MuiTooltip>
  </span>

))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 200,
  },
});
export { CustomWidthTooltip };

export default Tooltip;
